const DICTIONARIES = {
  en: {
    location: 'Shipper Location',
    name: 'Location Name',
    notes: 'Notes',
    operational_friday: 'Operational Friday',
    operational_holiday: 'Operational Holiday',
    operational_monday: 'Operational Monday',
    operational_saturday: 'Operational Saturday',
    operational_sunday: 'Operational Sunday',
    operational_thursday: 'Operational Thursday',
    operational_tuesday: 'Operational Tuesday',
    operational_wednesday: 'Operational Wednesday',
    type: 'Location Type',
    location_types: {
      origin: 'Origin',
      destination: 'Destination',
    },
  },
};

export default DICTIONARIES;
